module.exports = "<show-member [showAdminProfile]=\"true\">\n</show-member>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admin-profile/admin-profile.component.html
// module id = 450
// module chunks = 0